import { render, staticRenderFns } from "./ModelsGrid.vue?vue&type=template&id=21a03a8c&"
import script from "./ModelsGrid.vue?vue&type=script&lang=js&"
export * from "./ModelsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports